module.exports = __webpack_public_path__ + "img/기업네트워킹img.c91c93b0.png";